import { Content, Root, Trigger, View } from "./Dialog";

export const Dialog = { Root, Trigger, Content, View };
export { DeprecatedDialog } from "./_deprecated/DeprecatedDialog";
export { DialogLayout } from "./DialogLayout";
export * from "./types";
export { useDialogState } from "./use-dialog-state";
export { useDialogViews } from "./use-dialog-views";
